import { RSAA, RSAAction } from 'redux-api-middleware';

import { fetchFileAsBlob } from '../../../utils/fetchFileAsBlob/fetchFileAsBlob';

import * as types from './reportsActionTypes';

export const fetchReports = (): RSAAction<string, string, string> => ({
  [RSAA]: {
    endpoint: '/reports/xs2a/apistats',
    method: 'GET',
    types: [types.FETCH_REPORTS_REQUEST, types.FETCH_REPORTS_SUCCESS, types.FETCH_REPORTS_FAILURE],
  },
});

export const downloadReport = (reportName: string): RSAAction<string, string, string> => ({
  [RSAA]: {
    endpoint: `/reports/xs2a/apistats/${reportName}`,
    fetch: async (input: RequestInfo, init?: RequestInit) => {
      return fetchFileAsBlob(input, init, reportName);
    },
    method: 'GET',
    types: [types.DOWNLOAD_REPORT_REQUEST, types.DOWNLOAD_REPORT_SUCCESS, types.DOWNLOAD_REPORT_FAILURE],
  },
});
